module.exports = __webpack_public_path__ + "img/ssc.e62b9f0c.jpg";